<template>
	<div class="question-group" id="groupInstructions" v-if="group.GROUP_TEXT">
		<div v-if="!showInfo">
			<button class="pull-right btn" @click="showInfo=true" v-if="!showInfo" aria-controls="groupInfo">
				<i aria-label="expand question group information" class="fas fa-caret-down"></i>
			</button>
			<span class="hint">
				{{ $t('MAIN_CONTENT.QuestionGroup.message') }}
			</span>
		</div>

		<div id="groupInfo" v-if="showInfo">
			<h4>{{ group.GROUP_DESC }}</h4>
			<div v-html="group.GROUP_TEXT" />
			<button class="btn pull-right" @click="showInfo=false" v-if="groupText.length > 0">
				<i aria-label="collapse question group information" class="fas fa-caret-up"></i>
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			group: {
				default: function() {
					return {};
				}
			}
		},
		data() {
			return {
				showInfo: true
			};
		},
		computed: {
			groupText() {
				let groupText = !!this.group.GROUP_TEXT ? this.group.GROUP_TEXT : "";
				if(groupText.toLowerCase().indexOf("img") >= 0) {
					return groupText;
				}
				let span = document.createElement('span');
				span.innerHTML = groupText;
				return span.textContent || span.innerText;
			}
		}
	};
</script>
